import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { AddOrderFormComponent } from './add-order-form/add-order-form/add-order-form.component';
import { OrdersListComponent } from './orders/orders-list/orders-list.component';
import { OrdersTabsContainerComponent } from './orders-tabs-container/orders-tabs-container.component';
import { ListFilterModule } from '../list-filter/list-filter.module';
import { OrdersStartRealizationListComponent } from './orders-start-realization-list/orders-start-realization-list.component';
import { MassWorkerRealizationDateEditModalComponent } from './orders-start-realization-list/mass-worker-realization-date-edit-modal/mass-worker-realization-date-edit-modal.component';
import { OrdersRealizationListComponent } from './orders-realization-list/orders-realization-list.component';
import { EditOrderItemModalComponent } from './orders/orders-list/edit-order-item-modal/edit-order-item-modal.component';

@NgModule({
  declarations: [AddOrderFormComponent, OrdersListComponent, OrdersTabsContainerComponent, OrdersStartRealizationListComponent, MassWorkerRealizationDateEditModalComponent, OrdersRealizationListComponent, EditOrderItemModalComponent],
  imports: [CommonModule, SharedModule, ListFilterModule],
  exports: [AddOrderFormComponent],
})
export class OrdersModule {}
